module.exports = __webpack_public_path__ + "img/barre-parametres.35dc4ebd.svg";